import React, { useState } from "react";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CustomDialog from "./confirmationPopup/confirmationPopup";
import AppState from "../AppState";
import { useSelector } from "react-redux";
import { AppURLs } from "../constants";
import { useNavigate } from "react-router";

interface PageHeaderWithBackProps {
  osdNumber?: string | number;
  updatedDateTime?: string;
  headingTitle?: string;
  damageOsdNumber?: string | number;
  msdOsdNumber?: string | number;
}

const PageHeaderWithBack: React.FC<PageHeaderWithBackProps> = ({
  osdNumber,
  updatedDateTime,
  headingTitle,
  damageOsdNumber,
  msdOsdNumber
}) => {
  const navigate = useNavigate();
  const formValueChanged = useSelector(
    (state: AppState) => state.isFormValueChanged
  );
  const tabPosition: number = useSelector(
    (state: AppState) => state.tabPosition
  );
  // handle confirmation pop while user want back according button
  const [dialogOpen, setDialogOpen] = useState(false);
  // You may want to pass/set this from parent
  const urls: string[] = [
    AppURLs.searchException,
    AppURLs.myAssignments,
    AppURLs.overages,
    AppURLs.shortages,
    AppURLs.damages,
    AppURLs.onHandDelivery,
    AppURLs.misdelivery,
  ];

  const handleDialogOpenInternal = () => {
    if (damageOsdNumber && !formValueChanged) {
      navigate(AppURLs.damages);
      return;
    }
    if (msdOsdNumber && !formValueChanged) {
      navigate(`${AppURLs.mdEntry}/${msdOsdNumber}`);
      return;
    }
    if (!formValueChanged) navigate(urls[tabPosition] ?? urls[1]);
    setDialogOpen(true);
  };

  // Close the confirmation modal pop and navigate user to back overage listing page if user confirmed
  const handleDialogCloseInternal = (flag?: string) => {
    setDialogOpen(false);
    if (flag === "yes") {
      if (damageOsdNumber) {
        navigate(AppURLs.damages);
      } else {
        navigate(urls[tabPosition]);
      }
    }
  };

  return (
    <>
      <div className="header-section">
        <div className="back-section">
          <button className="back" onClick={handleDialogOpenInternal}>
            <ArrowLeftIcon />
          </button>
          <div className="page-hader-content">
            <div className="page-header" data-testid="overage-entry-title">
              {headingTitle}
            </div>
            {Boolean(osdNumber) && (
              <div data-testid="testid-last-update" className="page-subtitle">
                Last update: &nbsp;
                {updatedDateTime ?? "NA"}
              </div>
            )}
          </div>
          {Boolean(osdNumber) && <span className="badge">#{osdNumber} </span>}
        </div>
        <div className="edit-section"></div>
      </div>
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogCloseInternal}
      />
    </>
  );
};

// Suitable table name for this component: "osd_back_button_logs" or "user_navigation_logs"

export default PageHeaderWithBack;
